<template>
  <div>
    <v-dialog v-model="new_prop_dialog" max-width="800">
      <v-card>
        <v-card-text>
          <h3>Añadiendo propiedad a {{ intern_key }}</h3>
          <div>
            <v-text-field
              label="Nombre interno"
              v-model="new_prop_key"
              hide-details
              dense
              outlined
            ></v-text-field>
          </div>
        </v-card-text>
        <v-row justify="center" class="action-buttons">
          <v-col cols="2">
            <v-btn class="cancel-btn" @click="new_prop_dialog = false">Cancelar</v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn class="ok-btn" @click="addProp"
              :disabled="!new_prop_key || new_prop_key.includes(' ')">OK</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-row>
        <!-- {{ my_schema }} -->
    </v-row>
    <v-row class="schema-fields">
        
      <v-col cols="6">
        <v-text-field
          v-if="depth!=1"
          label="Nombre externo"
          v-model="my_schema.title"
          @input="schemaChanged"
          hide-details
          dense
          outlined
        ></v-text-field>
        <v-text-field
          v-else
          label="Nombre externo"
          v-model="intern_key"
          hide-details
          dense
          readonly
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-select
          label="Tipo"
          v-model="my_schema.type"
          :error="!my_schema.type"
          hide-details
          dense
          outlined
          @input="typeChanged"
          :items="type_items"
          item-value="value"
          item-text="name"
        ></v-select>
      </v-col>
    </v-row>
    <div v-if="my_schema.type === 'object' && my_schema.properties">
      <div class="nested-section" :style="{ marginLeft: depth * 20 + 'px' }">
        <v-row v-for="key in my_schema.required" :key="key">
          <v-col cols="3" style="margin-top: 30px;">
            <b>{{key}}:</b>
          </v-col>
          <v-col cols="7">
            <EntitySchemaEditorComponent
              :intern_key="key"
              @input="(new_data) => update_property(key, new_data)"
              v-model="my_schema.properties[key]"
              :depth="depth+1"
              :extra_types="extra_types"
            />
          </v-col>
          <v-col cols="1">
            <v-btn  style="margin-top: 30px; color:var(--v-primary-base)" class="delete-btn" @click="deleteProp(key)" icon>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1" >
            <v-row style="flex-direction: column; align-items: center; gap: 5px;margin-top: 20px;margin-right: 200px;">
              <v-btn 
                style="color:var(--v-primary-base)" 
                class="delete-btn" 
                @click="ascendProp(key)" 
                icon
              >
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn 
                style="color:var(--v-primary-base)" 
                class="delete-btn" 
                @click="descendProp(key)" 
                icon
              >
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-row>
            
            
          </v-col>
        </v-row>
        <v-row >
          <v-btn style="margin-left: 80px; color:var(--v-primary-base)" class="add-prop-btn" @click="newPropDialog" icon>
            <v-icon>mdi-plus</v-icon> (Añadir propiedad)
          </v-btn>
        </v-row>
      </div>
    </div>
    <div v-if="my_schema.type === 'array'">
      <div class="nested-section" :style="{ marginLeft: depth * 20 + 'px' }">
        <EntitySchemaEditorComponent
          :intern_key="'elemento lista '+intern_key"
          v-model="my_schema.items"
          :depth="depth+1"
          :extra_types="extra_types"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EntitySchemaEditorComponent",
  data() {
    return {
      my_schema: this.value !== null || this.value !== {} ? this.value : this.getDefaultPayload(),
      new_prop_key: '',
      new_prop_dialog: false,
    };
  },
  props: {
    intern_key: String,
    value: Object,
    depth: {
      type: Number,
      default: 1,
    },
    extra_types:{
        type: Array,
        default: () => [],
    }

  },
  mounted() {
    this.initializePayload();
  },
  computed:{
    type_items(){
        const default_types = [
                { value: 'object', name: 'Compuesto' },
                { value: 'array', name: 'Listado' },
                { value: 'string', name: 'Texto' },
                { value: 'number', name: 'Número' },
                { value: 'integer', name: 'Número Entero' },
                { value: 'boolean', name: 'Sí/No' },
                { value: 'any', name: 'Campo Libre'},
                // { value: 'null', name: 'Null' },
                // { value: 'customType', name: 'CustomType' },
                // { value: 'anotherType', name: 'AnotherType' }
                ]
        return [...default_types, ...this.extra_types]
    }
  },
  methods: {
    getDefaultPayload() {
      return { 'type': 'string', 'title': '' };
    },
    initializePayload() {
      if (!this.value || this.value === {}) {
        this.my_schema = this.getDefaultPayload(); //crec que mai entra aquí
      } else {
        this.my_schema = this.value;
      }
    },
    typeChanged() {
      if (this.my_schema.type === 'object') {
        this.my_schema['properties'] = {};
        this.my_schema['required'] = [];
      } else {
        delete this.my_schema['properties'];
        delete this.my_schema['required'];
      }
      if (this.my_schema.type === 'array') {
        this.my_schema['items'] = {};
      } else {
        delete this.my_schema['items'];
      }
      this.schemaChanged();
    },
    schemaChanged() {
      console.log('schema changed', this.intern_key, this.my_schema);
      this.my_schema = {...this.my_schema}
      this.$emit('input', this.my_schema);
    },
    newPropDialog() {
      this.new_prop_key = '';
      this.new_prop_dialog = true;
    },
    addProp() {
      this.new_prop_dialog = false;
      this.my_schema.properties = { ...this.my_schema.properties, [this.new_prop_key]: this.getDefaultPayload() };
      this.my_schema.required = [...this.my_schema.required, this.new_prop_key];
      this.new_prop_key = '';
      this.schemaChanged();
    },
    deleteProp(key) {
      delete this.my_schema.properties[key];
      this.my_schema.required = this.my_schema.required.filter((item) => item !== key);
      this.schemaChanged();
    },
    ascendProp(key) {
      const index = this.my_schema.required.indexOf(key);
      if (index > 0) {
        const temp = this.my_schema.required[index - 1];
        this.my_schema.required[index - 1] = key;
        this.my_schema.required[index] = temp;
        this.schemaChanged();
      }
    },
    descendProp(key) {
      const index = this.my_schema.required.indexOf(key);
      if (index < this.my_schema.required.length - 1) {
        const temp = this.my_schema.required[index + 1];
        this.my_schema.required[index + 1] = key;
        this.my_schema.required[index] = temp;
        this.schemaChanged();
      }
    },
    update_property(key, value) {
      console.log('update_property', key, value);
      this.my_schema.properties = {
        ...this.my_schema.properties,
        [key]: value,
      };
      this.schemaChanged();
    },
  },
};
</script>

<style scoped>
.schema-fields {
  margin-top: 20px;
}

.nested-section {
  padding-left: 10px;
  /*border-left: 3px solid #e0e0e0;*/
  margin-top: 15px;
  padding-bottom: 15px;
}

.action-buttons {
  margin-top: 10px;
}

.cancel-btn, .ok-btn, .delete-btn, .add-prop-btn {
  font-weight: bold;
}
</style>